import React from 'react';

function PrivacyModal({ onClose }) {
    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
            <div className="bg-white rounded-lg shadow-xl max-w-2xl w-full max-h-[80vh] flex flex-col">
                <div className="p-6 border-b border-gray-100 flex justify-between items-center">
                    <h2 className="text-2xl font-bold text-gray-800">Privacy Policy</h2>
                    <button
                        onClick={onClose}
                        className="text-gray-400 hover:text-gray-600 transition-colors text-2xl"
                    >
                        ×
                    </button>
                </div>

                <div className="p-6 overflow-y-auto">
                    <p className="mb-4 text-gray-600 italic">Last Updated: {new Date().toLocaleDateString()}</p>

                    <h3 className="text-lg font-bold mt-4 mb-2">1. Introduction</h3>
                    <p className="text-gray-700 mb-4">
                        Clackbase ("we", "our", or "us") respects your privacy. This Privacy Policy explains how we collect and use your personal information when you use our website (clackbase.com).
                    </p>

                    <h3 className="text-lg font-bold mt-4 mb-2">2. Information We Collect</h3>
                    <ul className="list-disc pl-5 mb-4 text-gray-700 space-y-2">
                        <li><strong>Account Information:</strong> When you login with Google, we collect your name, email address, and profile picture to create your user profile.</li>
                        <li><strong>Location Data:</strong> We use your browser's geolocation (with your permission) to show you nearby games. We do not track your location in the background.</li>
                        <li><strong>User Content:</strong> Any "Sessions" or "Clubs" you post, including location and description, are public information visible to all users.</li>
                    </ul>

                    <h3 className="text-lg font-bold mt-4 mb-2">3. How We Use Your Information</h3>
                    <p className="text-gray-700 mb-4">
                        We use your information solely to:
                        <br />- Provide the interactive map functionality.
                        <br />- Facilitate meetups between players.
                        <br />- Maintain the security of the platform.
                    </p>

                    <h3 className="text-lg font-bold mt-4 mb-2">4. Data Deletion</h3>
                    <p className="text-gray-700 mb-4">
                        You may request deletion of your account and data at any time by contacting us at <strong>support@clackbase.com</strong>.
                    </p>

                    <h3 className="text-lg font-bold mt-4 mb-2">5. Disclaimer</h3>
                    <p className="text-gray-700 mb-4">
                        Clackbase is a tool for finding chess games. We are not responsible for real-world interactions. Please use common sense and safety precautions when meeting strangers.
                    </p>
                </div>

                <div className="p-6 border-t border-gray-100 bg-gray-50 rounded-b-lg">
                    <button
                        onClick={onClose}
                        className="w-full bg-indigo-600 text-white py-2 px-4 rounded-lg hover:bg-indigo-700 transition-colors font-semibold"
                    >
                        Close
                    </button>
                </div>
            </div>
        </div>
    );
}

export default PrivacyModal;
